// src/config/api.config.js
// 统一从环境变量读取，支持多租户

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://shouyintaiapi.bdsplay.com';
export const WS_URL = process.env.REACT_APP_WS_URL || 'wss://shouyintaiapi.bdsplay.com/ws';
export const IMAGE_BASE_URL = API_BASE_URL;
export const TENANT = process.env.REACT_APP_TENANT || 'shouyintai';